import { ResponseBase } from '../Messaging/ResponseBase';

export class CheckNetworkResponse extends ResponseBase {
  /**
   * Whether the device is online or not.
   */
  isOnline!: boolean;
}
